import client from './client';

/**
 * Interview Blueprint Library API (backend: /api/blueprints).
 * Global blueprints are read-only for organizations; org blueprints are edited as drafts
 * and published as immutable versions.
 */
export const listLibraryBlueprints = () => client.get('/api/blueprints/library');
export const listOrgBlueprints = (orgId) => client.get('/api/blueprints', { params: { orgId } });
export const getBlueprint = (id) => client.get(`/api/blueprints/${id}`);
export const getBlueprintVersion = (versionId) => client.get(`/api/blueprints/versions/${versionId}`);
export const createBlueprint = (payload) => client.post('/api/blueprints', payload);
export const updateBlueprintDraft = (id, payload) => client.patch(`/api/blueprints/${id}`, payload);
export const deleteBlueprintDraft = (id) => client.delete(`/api/blueprints/${id}`);
export const copyBlueprint = (id, orgId, name) => client.post(`/api/blueprints/${id}/copy`, { orgId, name });
export const publishBlueprint = (id) => client.post(`/api/blueprints/${id}/publish`);
export const listBlueprintCards = (orgId) => client.get('/api/blueprints/cards', { params: orgId ? { orgId } : {} });
export const cardToItem = (cardId, orgId) => client.get(`/api/blueprints/cards/${cardId}/item`, { params: orgId ? { orgId } : {} });
export const getOrgBlueprintSettings = (orgId) => client.get(`/api/blueprints/org-settings/${orgId}`);
export const updateOrgBlueprintSettings = (orgId, payload) => client.put(`/api/blueprints/org-settings/${orgId}`, payload);

export const SENIORITY_OPTIONS = ['INTERN', 'JUNIOR', 'MID', 'SENIOR', 'LEAD', 'PRINCIPAL'];
export const INDUSTRY_SUGGESTIONS = ['general', 'fintech', 'healthcare', 'e-commerce', 'saas', 'edtech', 'gaming', 'logistics'];

export const titleCase = (s) => (s ? s.charAt(0) + s.slice(1).toLowerCase() : '');

/** Published versions an org can pin: Samastix Library + its own blueprints (current version each). */
export async function listPinnableVersions(orgId) {
  const [lib, own] = await Promise.all([
    listLibraryBlueprints().catch(() => ({ data: [] })),
    orgId ? listOrgBlueprints(orgId).catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
  ]);
  const rows = [...(own.data || []), ...(lib.data || [])];
  return rows
    .filter((b) => b.currentVersionId)
    .map((b) => ({
      versionId: b.currentVersionId,
      label: `${b.name} · v${b.currentVersionNo}${b.global ? ' (Samastix)' : ''}`,
      blueprint: b,
    }));
}
